// const apiUrlDevelopment = "http://dok.devrubu.com/api/";
// const apiUrlDevelopment = "https://dokapi.devrubu.com/"; //+
// const apiUrlDevelopment = "http://localhost:3030/";
// const apiUrlDevelopment = "http://192.168.2.44:3030/";
// const url = "http://192.168.2.212:3000/";  -
// const url = "https://dok.devrubu.com/"; //+
// const url = "http://192.168.2.44:3000/";
// const url = "http://localhost:3000/";
// const apiUrlWidget = "http://sign-widget-test.eu.iit.com.ua/";
// const apiUrlWidget = "http://signwidget.testkai.tk/";
// const apiUrlWidget = "http://localhost:3003/";

const url = "https://k-document-front.kai-doc.com.ua/";
const apiUrlDevelopment = "https://k-document-back.kai-doc.com.ua/";
const apiUrlWidget = "https://k-document-sign.kai-doc.com.ua/";


export const environment = {
  api: apiUrlDevelopment,
  url,
  apiWidget: apiUrlWidget,
  production: process.env.NODE_ENV === "production",
  development: process.env.NODE_ENV === "development",
};
